export const calculatedColumnsManagement = (selectedItems, changes, columns) => {
    if (selectedItems.some(item => item.dataField === 'cRMAddress.universityFacultyIDId') && !selectedItems.some(item => item.dataField === 'cRMAddress.cRMUniFaculty.universityIDId')) {
        const selectedItem = { dataField: 'cRMAddress.cRMUniFaculty.universityIDId', caption: this.$t('event.detail.university') }
        selectedItems.push({ ...selectedItem, disabled: false })
        this.list.selectItem(selectedItem)
    }

    columns.forEach(column => {
        const isSelected = selectedItems.some(item => item.dataField === column.dataField)
        if (column.visible !== isSelected) {
        changes.push({ ...column, visible: isSelected })
        }
    })

    const conditions = [
        { field: 'stageLatestFunding', internCode: 'investmenStage' },
        { field: 'closingDateLatestFunding', internCode: 'fundingClosingDate' },
        { field: 'cRMAddress.profiles[0].cRMFundingProfileV2s.investmentsTypeId', internCode: 'fundingMoneyInCHF' },
        { field: 'vLABEvaluations.cRMMitarbeiter.vorname', internCode: 'evaluationCasequality' }
    ]

    conditions.forEach(condition => {
        if (selectedItems.some(item => item.dataField === condition.field)) {
        const column = columns.find(item => item.internCode === condition.internCode)
        changes.push({ ...column, internVisible: true })
        }
    })

    if (selectedItems.some(item => ['supportIS', 'supportT100', 'supportVL', 'supportVK'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'unterstuetzung')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => item.dataField === 'totalFunding')) {
        const column = columns.filter(item => ['investmenStage', 'fundingMoneyInCHF', 'fundingStatusId'].includes(item.internCode))
        column.forEach(element => {
        changes.push({ ...element, internVisible: true })
        })
    }
    if (selectedItems.some(item => ['salutationId', 'salutationIdGender'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'addressSalutationId')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => ['birthday', 'ageGroup'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'addressBirthday')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => ['eVENTQuestionnairejoinedModulesJOrderIS2025s.eVENTEventStartupISModulesInnosuisse2025.joinedInnosuissemodules'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'joinedInnosuissemodules')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => ['eVENTQuestionnaireoprogramsJOrderIS2025.eVENTQuestionnaireOtherISprogramsIS2025.innosuisseprograms'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'innosuisseprograms')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => ['eVENTQuestionnairedinterestJOrderIS2025s.eVENTQuestionnairedescribesinterestIS2025.describesyourcurrentinterest'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'describesyourcurrentinterest')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => ['eVENTQuestionnaireUNDevGoalsJOrderIS2025s.eVENTQuestionnaireUNDevGoalsIS2025.uNSustainableDevelopmentGoals'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'uNSustainableDevelopmentGoals')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => ['iSsectorIDIS2025'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'isCoursesIsSector2025')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => ['iSstartupStageIDIS2025'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'isCoursesIsStartupStage2025')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => ['yearsOfIndustryExperienceIS2025'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'isCoursesYearsOfIndustryExperience2025')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => ['iScurrentRelationshipWithTheUniIS2025'].includes(item.dataField))) {
        const column = columns.find(item => item.internCode === 'isCoursesCurrentRelationshipWithTheUni2025')
        changes.push({ ...column, internVisible: true })
    }
    if (selectedItems.some(item => item.dataField === 'crmEvent.course_no')) {
        const columnsList = columns.filter(item => ['eventSortierdatum', 'eventEventlisttitleEN', 'eventLocationname'].includes(item.internCode))
        columnsList.forEach(column => {
        changes.push({ ...column, internVisible: true })
        })
    }
    if (selectedItems.some(item => item.isProfile === true)) {
        const columnsList = columns.filter(item => ['profileType', 'profileAdressId'].includes(item.internCode))
        columnsList.forEach(column => {
        changes.push({ ...column, internVisible: true })
        })
    }

    return changes
}
